module.exports = __webpack_public_path__ + "teleOne-90d3d66ffc8f07eea524b36de2893e48.png";